// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1997":"60779ec5","2635":"60779ec5"}[chunkId] + ".chunk.css";
};